import { useCallback } from 'react'
import { useApplyInputCouponCode } from '../../store/discountCoupon'
import { useDiscountCouponType } from '../../store/stateMachine/context'

export function useInputCouponCode() {
  const couponType = useDiscountCouponType()
  const apply = useApplyInputCouponCode()
  const changeCoupon = useCallback(() => {
    apply()
  }, [apply])
  return { couponType, changeCoupon }
}
